import request from '@/utils/request'
const transformRequest = (data) => {
  let ret = ""
  for (let it in data) {
    ret +=
      encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&"
  }
  return ret
}

// 删除收货地址
export function deleteAddress(data) {
  return request({
    url: 'user/delete_address',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 获取用户默认地址
export function getDefaultAddress() {
  return request({
    url: 'user/get_default_address',
    method: 'get',
  })
}

// 手表商品信息
export function goodsWatch() {
  return request({
    url: 'open/goods_watch',
    method: 'get',
  })
}


// 下单
export function confirm(data) {
  return request({
    url: 'order/confirm',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 我的订单
export function orders() {
  return request({
    url: 'user/orders',
    method: 'get',
  })
}


// 设置地址为默认
export function setDefaultAddress(data) {
  return request({
    url: 'user/set_default_address',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 用户地址列表
export function addressList() {
  return request({
    url: 'user/address_list',
    method: 'get',
  })
}

// 新增用户地址
export function add_address(data) {
  return request({
    url: 'user/add_address',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 修改用户地址
export function edit_address(data) {
  return request({
    url: 'user/edit_address',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 我的用户
export function customers() {
  return request({
    url: 'user/customers',
    method: 'get',
  })
}

// 积分转让
export function redeemTransfer(data) {
  return request({
    url: 'redeem/transfer',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 库存下单
export function makeOrder(data) {
  return request({
    url: 'redeem/make_order',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 积分转让统计
export function redeemStats(params) {
  return request({
    url: 'redeem/stats',
    method: 'get',
    params,
    transformRequest: transformRequest
  })
}

// 库存下单记录
export function redeemStockOrders(params) {
  return request({
    url: 'redeem/stock_orders',
    method: 'get',
    params,
    transformRequest: transformRequest
  })
}

// 积分转让记录
export function redeemOutpage(params) {
  return request({
    url: 'redeem/outpage',
    method: 'get',
    params,
    transformRequest: transformRequest
  })
}

// 登录
export function login(params) {
  return request({
    url: 'open/login',
    method: 'post',
    params,
  })
}

// 注册
export function register(data) {
  return request({
    url: 'open/register',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 发送验证码
export function send_vcode(data) {
  return request({
    url: 'open/send_vcode',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 找回密码
export function recover_passwd(data) {
  return request({
    url: 'open/recover_passwd',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 个人信息
export function selflinfo() {
  return request({
    url: 'user/selfinfo',
    method: 'get',
  })
}

// 用户主页
export function userHome() {
  return request({
    url: 'user/home',
    method: 'get',
  })
}

// 修改昵称
export function change_nickname(data) {
  return request({
    url: 'user/change_nickname',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 上传图片
export function upload_pic(data) {
  return request({
    url: 'user/upload_pic',
    method: 'post',
    data,
  })
}

// 修改头像
export function change_avatar(data) {
  return request({
    url: 'user/change_avatar',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 修改支付密码
export function change_paypasswd(data) {
  return request({
    url: 'user/change_paypasswd',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 修改登陆密码
export function change_passwd(data) {
  return request({
    url: 'user/change_passwd',
    method: 'post',
    data,
    transformRequest: transformRequest
  })
}

// 我的积分
export function my_redeems() {
  return request({
    url: 'redeem/my_redeems',
    method: 'get',
  })
}
